import React from 'react';
import { DESKTOP_CONTENT_WIDTH } from '../../constants';
import { AssetBlockProps } from '../../pages/Asset';

export const Map: React.FC<AssetBlockProps> = ({ asset }) => {
  const lat = asset.mapInformation?.location.lat;
  const long = asset.mapInformation?.location.long;

  return (
    <div
      onClick={() => {
        window.open(`https://google.com/maps/place/${lat},${long}/@${lat},${long},14z`, '_blank');
      }}
      style={{ borderRadius: 10 }}>
      <img
        style={{ borderRadius: 10 }}
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${long}&zoom=11&size=${DESKTOP_CONTENT_WIDTH}x226&style=&markers=${lat},${long}&key=AIzaSyAZKMoXSNlcFPxTCT3nVY5GsOBItH_OHTg`}></img>
    </div>
  );
};
